import styled from "styled-components";

export const ListDisplayContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ChecklistSeriesInfoContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;
`
export const HeaderContent = styled.div`
    background: rgba(255, 255, 255, 0.1);
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px;
`

export const ChecklistTitle = styled.h2`
    font-family: 'Roboto Condensed';
    font-size: 32px;
    font-weight: 600;
    color: #FFFFFF;
    margin: 0;
    opacity: 1;
`

export const LeftContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`
export const ChecklistAttributes = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`
export const RightContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
`

export const ChecklistImage = styled.img`
    border: 2px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    width: 296px;
    height: auto;
    border-radius: 8px;
`;
export const FiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`
export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
export const CardTypeBoxesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

export const AddCustomCardTypeBox = styled.div`
    align-items: center;
    background: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.2)' : ''};
    border: 2px solid ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.2)'};
    border-radius: 8px;
    display: flex;
    gap: 8px;
    box-sizing: border-box;
    height: 48px;
    justify-content: center;
    padding: 8px 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 64px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;

    &:hover {
        background: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
        border-color: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.3)'};
        transform: ${props => props.$isSelected ? '' : 'translateY(-1px)'};

    }

    &:active {
        transform: translateY(0);
    }
`

export const CardTypeBox = styled.div`
    align-items: center;
    background: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
    border: 2px solid ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.2)'};
    border-radius: 8px;
    display: flex;
    gap: 8px;
    box-sizing: border-box;
    height: 48px;
    justify-content: center;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 64px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    position: relative;

    &:hover {
        background: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
        border-color: ${props => props.$isSelected ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.3)'};
        transform: ${props => props.$isSelected ? '' : 'translateY(-1px)'};

    }

    &:active {
        transform: translateY(0);
    }
`

export const CardTypeBoxContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    justify-content: center;
`

export const CategoryOptionsIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    color: rgba(255, 255, 255, 0.7);
    
    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 1);
    }
    
    svg {
        font-size: 18px;
    }
`
export const CardTypeBoxCount = styled.div` 
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    display: flex;
    gap: 8px;
    padding: 4px 8px;
    width: fit-content;
    
    img {
        width: 12px;
    }
`